import { Link } from 'react-router-dom';

const baseClasses = {
  sm: 'h-8',
  md: 'h-9',
  lg: 'h-11',
  xl: 'h-14',
};

const textClasses = {
  sm: {
    name: 'text-lg tracking-[0.24em]',
    sub: 'text-[9px] tracking-[0.45em]',
    gap: 'gap-3',
  },
  md: {
    name: 'text-xl tracking-[0.24em]',
    sub: 'text-[10px] tracking-[0.48em]',
    gap: 'gap-3.5',
  },
  lg: {
    name: 'text-2xl tracking-[0.28em]',
    sub: 'text-[11px] tracking-[0.52em]',
    gap: 'gap-4',
  },
  xl: {
    name: 'text-4xl tracking-[0.28em]',
    sub: 'text-sm tracking-[0.56em]',
    gap: 'gap-5',
  },
};

export default function BrandLogo({
  to = '/',
  size = 'md',
  className = '',
  imageClassName = '',
  framed = false,
  alt = 'YAMASS Bangladesh',
}) {
  const textSize = textClasses[size] || textClasses.md;
  const content = (
    <div
      className={[
        'inline-flex items-center',
        textSize.gap,
        framed ? 'rounded-2xl bg-white/95 p-3 shadow-lg ring-1 ring-black/5' : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      <img
        src="/brand/yamass-logo-present.png"
        alt={alt}
        className={[
          'w-auto shrink-0 object-contain',
          baseClasses[size] || baseClasses.md,
          imageClassName,
        ].filter(Boolean).join(' ')}
      />
      <div className="flex flex-col items-start justify-center leading-none">
        <span className={['font-display font-bold text-yamass-black', textSize.name].join(' ')}>
          YAMASS
        </span>
        <span className={['mt-1 text-gray-500 uppercase', textSize.sub].join(' ')}>
          Bangladesh
        </span>
      </div>
    </div>
  );

  if (!to) return content;

  return (
    <Link to={to} aria-label={alt} className="inline-flex items-center">
      {content}
    </Link>
  );
}
